var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpiThresholdDownV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_113159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1489L32 16.1489C32 7.31237 24.8366 0.148926 16 0.148926C7.16344 0.148926 0 7.31237 0 16.1489Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.1488H28.448V14.5488H32V16.1488ZM24.896 16.1488H21.344V14.5488L24.896 14.5488V16.1488ZM17.792 16.1488L14.24 16.1488V14.5488H17.792V16.1488ZM10.688 16.1488H7.136V14.5488L10.688 14.5488V16.1488ZM3.584 16.1488H0L0 14.5488H3.552V16.1488H3.584Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.52 27.0931L30.624 19.6211C30.592 19.3811 30.288 19.2691 30.112 19.4451L27.888 21.6691L17.712 11.4931C17.472 11.2531 17.104 11.2531 16.864 11.4931L13.04 15.3011L2.67198 4.94914C2.67198 4.94914 2.54398 4.86914 2.46398 4.86914C2.38398 4.86914 2.30398 4.90114 2.25598 4.94914L0.55998 6.64514C0.55998 6.64514 0.47998 6.77314 0.47998 6.85314C0.47998 6.93314 0.51198 7.01314 0.55998 7.06114L12.624 19.1251C12.864 19.3651 13.232 19.3651 13.472 19.1251L17.296 15.3171L25.776 23.7971L23.552 26.0211C23.552 26.0211 23.488 26.1171 23.472 26.1651C23.472 26.2131 23.472 26.2771 23.472 26.3251C23.488 26.3731 23.52 26.4211 23.568 26.4531C23.616 26.4851 23.664 26.5171 23.728 26.5171L31.2 27.4131C31.392 27.4451 31.552 27.2691 31.536 27.0771L31.52 27.0931Z",
    fill: "#595959"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_113159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 27.28,
    fill: "white",
    transform: "translate(0 0.148926)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiThresholdDownV2);
export default __webpack_public_path__ + "static/media/kpi-threshold-down-v2.bc3b14e1.svg";
export { ForwardRef as ReactComponent };